<div class="flash">
  <div class="alert" *ngFor="let alert of alerts">{{ alert }}</div>
  <div class="notice" *ngFor="let notice of notices">{{ notice }}</div>
  <div class="error" *ngFor="let error of errors">{{ error }}</div>
</div>
